import { defineMessages } from 'react-intl';

export default defineMessages({
  areYouClaimingForDamaged: {
    id: 'fastCover.stepSportsEquipment.areYouClaimingForDamaged',
    defaultMessage: 'Are you claiming for Damaged, Lost, or Stolen Luggage?',
  },
  areYouClaimingForBaggageDelay: {
    id: 'fastCover.stepSportsEquipment.areYouClaimingForBaggageDelay',
    defaultMessage: 'Are you claiming for Baggage Delay?',
  },
  travelSupplierOrProviderInformation: {
    id: 'fastCover.stepSportsEquipment.travelSupplierOrProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },
  nameOfTourOperatorOrCruiseOrLineOrAirline: {
    id: 'fastCover.stepSportsEquipment.travelSupplierOrProviderInformation',
    defaultMessage: 'Name of Tour Operator/Cruise Line/Airline you were traveling with:',
  },
  origination: {
    id: 'fastCover.stepSportsEquipment.origination',
    defaultMessage: 'Origination',
  },

  flightNumber: {
    id: 'fastCover.stepSportsEquipment.flightNumber',
    defaultMessage: 'Flight Number',
  },

  airCarrier: {
    id: 'fastCover.stepSportsEquipment.airCarrier',
    defaultMessage: 'AirCarrier',
  },

  destination: {
    id: 'fastCover.stepSportsEquipment.destination',
    defaultMessage: 'Destination',
  },
  sectionTitle: {
    id: 'fastCover.stepSportsEquipment.sectionTitle',
    defaultMessage:
      'Section 4 - Damaged, Lost or Stolen Luggage, Travel Documents or Cash',
  },
  yes: {
    id: 'fastCover.stepSportsEquipment.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepSportsEquipment.no',
    defaultMessage: 'No',
  },
  areYouClaimingForLossTheftOrDamageTo: {
    id: 'fastCover.stepSportsEquipment.areYouClaimingForLossTheftOrDamageTo',
    defaultMessage: 'Are you claiming for Loss, Theft or Damage to:',
  },
  passportsCreditCards: {
    id: 'fastCover.stepSportsEquipment.passportsCreditCards',
    defaultMessage: 'Passports, Credit Cards & Credit Card Fraud?',
  },
  theftOfCash: {
    id: 'fastCover.stepSportsEquipment.theftOfCash',
    defaultMessage: 'Theft of Cash',
  },
  luggageAndPersonalEffects: {
    id: 'fastCover.stepSportsEquipment.luggageAndPersonalEffects',
    defaultMessage: 'Luggage and Personal Items',
  },
  luggageInclude: {
    id: 'fastCover.stepSportsEquipment.luggageInclude',
    defaultMessage:
      'Luggage includes your bags, clothes, devices and other personal belongings.',
  },
  toAssistYourClaim: {
    id: 'fastCover.stepSportsEquipment.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.stepSportsEquipment.toAssistYourClaim',
    defaultMessage:
      'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.stepSportsEquipment.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation',
  },
  document: {
    id: 'fastCover.stepSportsEquipment.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.stepSportsEquipment.document1',
    defaultMessage:
      'Police report or written report from a relevant authority or Travel Provider (Airline, hotel, Cruise Liner, Tour Company etc.)',
  },
  document2: {
    id: 'fastCover.stepSportsEquipment.document2',
    defaultMessage: 'Damage or Repair report',
  },
  document3: {
    id: 'fastCover.stepSportsEquipment.document3',
    defaultMessage: 'Quote for repair or replacement',
  },
  document4: {
    id: 'fastCover.stepSportsEquipment.document4',
    defaultMessage:
      'Purchase receipt or other Evidence of Ownership for each item claimed',
  },
  document5: {
    id: 'fastCover.stepSportsEquipment.document5',
    defaultMessage:
      "For all losses or delays caused by your Transport Provider, a 'Property Irregularity Report' from the Transport Provider",
  },
  document6: {
    id: 'fastCover.stepSportsEquipment.document6',
    defaultMessage:
      'Written evidence from the Transport Provider confirming the days and hours your luggage was delayed and the time that it was returned to you',
  },
  document7: {
    id: 'fastCover.stepSportsEquipment.document7',
    defaultMessage: 'Receipts for essential clothing and toiletries purchased',
  },
  document8: {
    id: 'fastCover.stepSportsEquipment.document8',
    defaultMessage:
      'For Cash claims, Bank or Credit Card statements or ATM or Currency Conversion receipts showing withdrawal of funds',
  },
  document9: {
    id: 'fastCover.stepSportsEquipment.document9',
    defaultMessage:
      'For mobile phone claims please block the IMEI letter with your network provider',
  },
  provideExplanation: {
    id: 'fastCover.stepSportsEquipment.provideExplanation',
    defaultMessage:
      'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  luggageWasLostStolenOrDamaged: {
    id: 'fastCover.stepSportsEquipment.luggageWasLostStolenOrDamaged',
    defaultMessage:
      'If your luggage was lost, stolen or damaged please tell us:',
  },
  howItHappened: {
    id: 'fastCover.stepSportsEquipment.howItHappened',
    defaultMessage: '1. How it happened',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepSportsEquipment.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.stepSportsEquipment.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.stepSportsEquipment.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.stepSportsEquipment.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.stepSportsEquipment.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.stepSportsEquipment.delay',
    defaultMessage: 'Delay',
  },
  police: {
    id: 'fastCover.stepSportsEquipment.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.stepSportsEquipment.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.stepSportsEquipment.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.stepSportsEquipment.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.stepSportsEquipment.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.stepSportsEquipment.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.stepSportsEquipment.notReported',
    defaultMessage: 'Not Reported',
  },
  descriptionOfItem: {
    id: 'fastCover.stepSportsEquipment.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.stepSportsEquipment.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.stepSportsEquipment.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.stepSportsEquipment.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.stepSportsEquipment.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.stepSportsEquipment.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.stepSportsEquipment.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.stepSportsEquipment.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.stepSportsEquipment.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.stepSportsEquipment.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.stepSportsEquipment.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.stepSportsEquipment.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepSportsEquipment.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepSportsEquipment.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.stepSportsEquipment.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.stepSportsEquipment.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.stepSportsEquipment.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.stepSportsEquipment.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.stepSportsEquipment.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.stepSportsEquipment.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.stepSportsEquipment.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.stepSportsEquipment.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.stepSportsEquipment.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.stepSportsEquipment.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.stepSportsEquipment.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.stepSportsEquipment.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.stepSportsEquipment.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.stepSportsEquipment.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.stepSportsEquipment.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepSportsEquipment.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.stepSportsEquipment.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.stepSportsEquipment.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.stepSportsEquipment.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.stepSportsEquipment.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.stepSportsEquipment.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.stepSportsEquipment.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.stepSportsEquipment.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.stepSportsEquipment.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  otherInsuranceAuthorization: {
    id: 'fastCover.stepSportsEquipment.otherInsuranceAuthorization',
    defaultMessage: 'OTHER INSURANCE / AUTHORISATION:',
  },
  companyName: {
    id: 'fastCover.stepSportsEquipment.companyName',
    defaultMessage: 'Company Name',
  },
  typeOfPolicy: {
    id: 'fastCover.stepSportsEquipment.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },
  policy: {
    id: 'fastCover.stepSportsEquipment.policy',
    defaultMessage: 'Policy',
  },
  lossInformation: {
    id: 'fastCover.stepSportsEquipment.lossInformation',
    defaultMessage: 'Loss Information',
  },
  dateOfLoss: {
    id: 'fastCover.stepSportsEquipment.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },
  pleaseDescribeWhatOccurred: {
    id: 'fastCover.stepSportsEquipment.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please describe what occurred:',
  },
  placeOfLoss: {
    id: 'fastCover.stepSportsEquipment.placeOfLoss',
    defaultMessage: 'Place of Loss:',
  },
  name: {
    id: 'fastCover.stepSportsEquipment.name',
    defaultMessage: 'Name',
  },
  address: {
    id: 'fastCover.stepSportsEquipment.address',
    defaultMessage: 'Address',
  },
  contact: {
    id: 'fastCover.stepSportsEquipment.contactF',
    defaultMessage: 'Contact',
  },
  phone: {
    id: 'fastCover.stepSportsEquipment.phone',
    defaultMessage: 'Phone',
  },
  delayInformation: {
    id: 'fastCover.stepSportsEquipment.delayInformation',
    defaultMessage: 'Delay Information',
  },
  lossInformationWithIdx: {
    id: 'fastCover.stepSportsEquipment.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },
  haveYouReceivedReimbursement: {
    id: 'fastCover.stepSportsEquipment.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },
  howMuchReceivedReimbursement: {
    id: 'fastCover.stepSportsEquipment.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },
  fromWhom: {
    id: 'fastCover.stepSportsEquipment.fromWhom',
    defaultMessage: 'If so, from whom?',
  },
  delayInformationWithIdx: {
    id: 'fastCover.stepSportsEquipment.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.stepSportsEquipment.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },
  haveYouMadeAClaimWithYourTravelProvider: {
    id: 'fastCover.stepSportsEquipment.haveYouMadeAClaimWithYourTravelProvider',
    defaultMessage: 'Have you made a claim with your Travel provider?',
  },
  itemDescription: {
    id: 'fastCover.stepSportsEquipment.itemDescription',
    defaultMessage: 'Item Description',
  },
  estimatedValue: {
    id: 'fastCover.stepSportsEquipment.estimatedValue',
    defaultMessage: 'Estimated Value',
  },
  scheduledDateOfReturn: {
    id: 'fastCover.stepSportsEquipment.scheduledDateOfReturn',
    defaultMessage: 'Scheduled Date of Return',
  },
  scheduledDateOfDeparture: {
    id: 'fastCover.stepSportsEquipment.scheduledDateOfDeparture',
    defaultMessage: 'Scheduled Date of Departure',
  },
  areYouClaimingForALostItem: {
    id: 'fastCover.stepSportsEquipment.areYouClaimingForALostItem',
    defaultMessage: 'Are you claiming for lost items?',
  },
  areYouClaimingForValuables: {
    id: 'fastCover.stepSportsEquipment.areYouClaimingForValuables',
    defaultMessage: 'Are you claiming for valuables?',
  },
  areYouClaimingForBaggageDelayPerDay: {
    id: 'fastCover.stepSportsEquipment.areYouClaimingForBaggageDelayPerDay',
    defaultMessage: 'Are you claiming for Baggage Delay (Per Day)?',
  },
  areYouClaimingForLostSportsEquipmentRental: {
    id: 'fastCover.stepSportsEquipment.areYouClaimingForLostSportsEquipmentRental',
    defaultMessage: 'Are you claiming for Lost Sports Equipment Rental?',
  },
  areYouClaimingForLostSportsEquipment: {
    id: 'fastCover.stepSportsEquipment.areYouClaimingForLostSportsEquipment',
    defaultMessage: 'Are you claiming for Lost Sports Equipment?',
  },
  areYouClaimingForSportsEquipmentDelay: {
    id: 'fastCover.stepSportsEquipment.areYouClaimingForSportsEquipmentDelay',
    defaultMessage: 'Are you claiming for Sports Equipment Delay?',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.SportsEquipmentStep/messages.js